import { Button, Grid, Typography } from '@mui/material';
import { Link } from 'react-router';

export default function DataPoolList({
  dataPools,
}: {
  dataPools?: Array<{ id: string; label: string }>;
}) {
  // orgId will be undefined for non-staff who has more than one org
  // needs a dropdown to select org, gather spec first
  return (
    <Grid
      container
      id="select-data-pool"
      direction="column"
      justifyContent="center"
      alignItems="center"
    >
      {dataPools ? (
        <>
          <Typography variant="h6" align="center" data-cy="data-pool-list-title">
            Please select your data pool below
          </Typography>
          <Grid container direction="column" justifyContent="center" alignItems="center">
            {dataPools.map((dp) => (
              <Button
                component={Link}
                to={`/data-pools/${dp.id}/extraction-batches`}
                data-testid="datapool-button"
                variant="contained"
                color="primary"
                style={{ margin: '1em', width: '300px' }}
                key={dp.id}
              >
                {dp.label}
              </Button>
            ))}
          </Grid>
        </>
      ) : (
        <Typography variant="h6" align="center" data-testid="no-datapool">
          No data pool is assigned to your account. Please contact your Glynt representative.
        </Typography>
      )}
    </Grid>
  );
}
